<template>
  <div>
    <div v-if='obras.length'>
      <template v-for="(obra,index) in obras">
        <book-simple v-if="obra" :obra="obra" type="simple" @tag="filterByTagEvt($event)" @recomendar='recomendar($event)' :key="`obra-${index}`"/>
      </template>
    </div>
    <div v-else>
      <card title='Nenhum Registro Encontrado'>
        <div></div>
      </card>
    </div>
  </div>
</template>
<script>
import ObraService from '../../services/obra-service'
import OverlayService from '../../services/overlay-service'
import BookSimple from '@/components/BookSimple'

export default {
  components: {
    BookSimple
  },
  props: {
    obras: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  methods: {
    filterByTagEvt (id) {
      this.$emit('filterByTag', id)
    },

    orderByParam (param) {
      console.log(param)
    },

    recomendar (obra) {
      const value = !obra.recomendado
      OverlayService.trigger('show', true)

      ObraService.recomendar(obra.id, value)
        .then(() => {
          OverlayService.trigger('show', false)
          obra.recomendado = value
        })
        .catch(er => OverlayService.trigger('show', false))
    }
  }
}
</script>
